import React, { Component } from "react";
import { Link } from "react-router-dom";
import { Helmet } from 'react-helmet';
import './Face.css';
import Cookies from "js-cookie";
import * as actions from '../Actions';
import { fetchInitialData } from "../../fetchData";
import Swiper from 'swiper'
import Right from '../../right/Right';
import Service from '../../service/Service';


const service = new Service();

class SlideShow extends Component {
    constructor(props) {
        super(props);
        let FaceData = [];

        if (__isBrowser__ && window.__initialData__ && window.__initialData__['initialData'] && window.__initialData__['initialData']['result']) {
            FaceData = window.__initialData__['initialData']['result'];
            delete window.__initialData__;
        } else {
            if (props.staticContext && props.staticContext.initialData && props.staticContext.initialData['initialData'] && props.staticContext.initialData['initialData']['result']) {
                FaceData = props.staticContext.initialData['initialData']['result'];
            }
        }
        this.state = {
            FaceData:FaceData,
            childListData:global.userAry['childData']['UserChildList'],
            yearData:[],
            monthAry : ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"],
            shortMonth: ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"],
            currentDate:new Date(),
            faceCnt:0,
            cFlag: false,
            isMobile:'',
            mySwiper:'',
            timerId:'',
            timerValue : 100,
            isSliderPaused :false,
            fullWidth :100,
            sliderDelay : 7000,
            frameDate:'',
            selectchildName:Cookies.get('ChildName'),
            selectedChild:'',
            ChildDob:'',
            childPhoto:'',
            month:'',
            IsExpected: false
        }
    }
    static initialAction(reqUrl, ftk, authData, uId,childData,cookie) {
        var selectedChild='';
        var sMonth = '';
        var sYear = '';
        var ChildName='';
        if (cookie) {
            var cookieAry = cookie.split(';');
            for (var i = 0; i < cookieAry.length; i++) {
                if (cookieAry[i].includes("slideMonth")) {
                    sMonth = cookieAry[i].split('slideMonth=')[1];
                }
                if (cookieAry[i].includes("slideShowYr")) {
                    sYear = cookieAry[i].split('slideShowYr=')[1];
                }
                if (cookieAry[i].includes("ChildName")) {
                    ChildName = cookieAry[i].split('ChildName=')[1];
                }
            }
        }
        for(var i=0;i<childData['UserChildList'].length;i++){
            if(childData['UserChildList'][i].ChildName==ChildName){
                selectedChild=childData['UserChildList'][i].ChildId;
            }
        }
        var header = {
            'Content-Type': 'application/json',
            'ftk': global.ftk,
            'uid': global.uID,
            'access-token': global.accessToken,
            'user-agent': global.userAgent,
            'isdesktop': global.isdesktop
        }
        var url = global.api_url + "face/getfacememorydata";
        let body = JSON.stringify({
            "childId":selectedChild,
            "month": sMonth,
            "year" :sYear
        });
        return fetchInitialData(url, JSON.stringify(header), body);
    }
    componentDidMount() {
        document.addEventListener("click", this.domClick);
        console.log("FaceData====================>",this.state.FaceData);
        for(var i=0;i<this.state.childListData.length;i++){
            if(this.state.childListData[i].ChildName==this.state.selectchildName){
                this.state.selectedChild=this.state.childListData[i].ChildId;
            }
        }
        this.setState({ isMobile: window.innerWidth });
        if (global.userAry['IsExpected']) {
            this.setState({ IsExpected: true });
        } else {
            this.setState({ IsExpected: false });
        }
        if (navigator.onLine) {
            if (!this.state.FaceData || (this.state.FaceData && Object.keys(this.state.FaceData).length < 1)) {
                service.showLoader();
                this.getFaceData(this.state.selectedChild);
            } else {
                localStorage.setItem('FaceData', JSON.stringify(this.state.FaceData));
                this.OnloadData();
            }
            service.hideLoader();
        }else {
            if (localStorage.getItem('FaceData')) {
                this.setState({ FaceData: JSON.parse(localStorage.getItem('FaceData'))},() => {this.OnloadData();
                });
            }
            service.hideLoader();
        }
        
    }
    getFaceData(selectedChild) {
        var month=Cookies.get('slideMonth');
        var year=Cookies.get('slideShowYr');
        // console.log("getFaceData========================>",selectedChild,month,year);
        var postData={
                "childId":selectedChild,
                "month":month,
                "year":year
            };
            console.log("postData=========>",postData);
        // var url= global.api_url + "face/getfacememorydata";
        var url = global.api_ci_url + "Face/getSlideFaceData";
        service.postServiceCall(url, postData).then((json) => {
            // console.log("framelist==============>",json['result']);
            if (json['result']) {
                this.setState({
                    FaceData: json['result'],
                }, () => { this.OnloadData(); });
                localStorage.setItem('FaceData', JSON.stringify(json));
            }
            service.hideLoader();
        }).catch((error) => {
            console.error(error);
            service.hideLoader();
        });
    }
    OnloadData(){
        if (!global.ftk) {
            this.props.history.push('/tools/capture-baby-moments');
        } else {
            var sMonth = Cookies.get('slideShowMon');
            var sYear = Cookies.get('slideShowYr');
            if (sMonth != "" && Cookies.get('slideMonth') != "00") {
                this.state.month=sMonth + " " + sYear;
            } else {
                this.state.month=sYear;
            }
        }
        if(this.state.FaceData){
            document.querySelector(".play").style.display="none";
            document.querySelector(".pause").style.display="block";
            document.querySelector(".face_star").style.display="block";

            this.state.mySwiper = new Swiper('.swiper-container', {
                effect: 'coverflow',
                centeredSlides: true,
                loop: false,
                slidesPerView: 2,
                coverflowEffect: {
                    rotate: 0,
                    stretch: 0,
                    depth: 350,
                    modifier: 1,
                    slideShadows: false
                },
                breakpoints: {
                    480: {
                        slidesPerView: 2
                    }
                },
                autoplay: {
                    enabled: false,
                    delay: this.state.sliderDelay,
                    waitForTransition: true,
                    disableOnInteraction: true,
                    stopOnLastSlide: false,
                    reverseDirection: false,
                }
            });
        }
        if (window.innerWidth < 767) {
            var clickhereleft = (window.innerWidth - 80) / 2;
            document.querySelector(".clickhere").style.left=clickhereleft;
        }
        if(this.state.FaceData == "No Data Found" || this.state.FaceData=="Unsuccess"){
        }else{
            this.state.faceCnt= this.state.FaceData.length;
        }
    this.loadMsiteClasses() 

    }
    playVideo () {
        console.log("playVideo=============>")
        console.log("count=============>",this.state.faceCnt)
        if (this.state.faceCnt > 0) {
            if (!this.state.cFlag) {
                document.querySelector(".pause").style.display="none";
                document.querySelector(".play").style.display="block";
                document.querySelector(".face_star").style.display="none";
                this.state.cFlag = true
            } else {
                document.querySelector(".play").style.display="none";
                document.querySelector(".pause").style.display="block";
                this.state.cFlag = false
            }
            this.initializeSlider(this.state.cFlag)
        } else {
            document.querySelector(".alertmsg").innerHTML=("Kindly upload at least one image to run slideshow");
            document.querySelector(".alert-popup").style.left= '35%';
            document.querySelector('.alertMsg-overlay').style.display="block";
            setTimeout(() => {
                document.querySelector('.alertMsg-overlay').style.display="block";
                this.props.history.push('/tools/capture-baby-moments'); 
            }, 100);
        }
    }
    initializeSlider(flag) {
        if ((flag && this.state.timerValue == 100) || (!flag && this.state.timerValue >= (this.state.faceCnt * this.state.sliderDelay) + 100)) {
            this.state.mySwiper.destroy();
            this.state.mySwiper = new Swiper('.swiper-container', {
                effect: 'coverflow',
                centeredSlides: true,
                loop: false,
                slidesPerView: 2,
                coverflowEffect: {
                    rotate: 0,
                    stretch: 0,
                    depth: 350,
                    modifier: 1,
                    slideShadows: false
                },
                breakpoints: {
                    480: {
                        slidesPerView: 2
                    }
                },
                autoplay: {
                    enabled: flag,
                    delay: this.state.sliderDelay,
                    waitForTransition: true,
                    disableOnInteraction: true,
                    stopOnLastSlide: false,
                    reverseDirection: false
                }
            })
        } else {
            if (this.state.isSliderPaused) {
                this.state.mySwiper.autoplay.start();
                this.state.isSliderPaused = false
            } else {
                this.state.mySwiper.autoplay.stop();
                this.state.isSliderPaused = true
            }
        }
        if (flag) {
            var faceAudio = document.getElementById("faceAudio");
            faceAudio.play();
            // console.log("this.state.timerValue====>2",this.state.timerValue)
            // console.log("this.state.timerValue====>3",(parseInt(this.state.faceCnt) * this.state.sliderDelay))
            this.state.timerId = setInterval(() => {
                // console.log("this.state.timerValue====>4",this.state.timerValue);
                if (this.state.timerValue >= (parseInt(this.state.faceCnt) * this.state.sliderDelay) + 100) {
                    this.initializeSlider(false);
                } else {
                // console.log("this.state.timerValue====>5",this.state.timerValue);
                    var percentage = (this.state.timerValue / (parseInt(this.state.faceCnt) * this.state.sliderDelay)) * 100;
                    if (percentage == 0) {
                        document.querySelector("#active-bar").style.width="11px";
                    } else {
                        console.log("percentage==================>",percentage);
                        document.querySelector("#active-bar").style.width=percentage+"%";
                    }
                    this.state.timerValue = this.state.timerValue + 100
                }
              }, 100);
        } else {
            var faceAudio = document.getElementById("faceAudio");
            faceAudio.pause();
            if (this.state.timerValue >= (this.state.faceCnt * this.state.sliderDelay) + 100) {
                clearInterval(this.state.timerId);
                document.querySelector(".play").style.display="none";
                document.querySelector(".pause").style.display="block";
                document.querySelector(".face_star").style.display="block";
                this.state.timerValue = 100;
                this.state.cFlag = false;
                const setWidthId = setInterval(() => {
                    this.state.fullWidth = this.state.fullWidth - 1;
                    if (this.state.fullWidth > 0) {
                        // console.log("percentage==================>1",percentage);
                        document.querySelector("#active-bar").style.width=this.state.fullWidth + "%";
                    } else {
                        document.querySelector("#active-bar").style.width="11px";
                        clearInterval(setWidthId);
                        this.state.fullWidth = 100
                    }
                }, 10);
            } else {
                var currentSlide = this.state.mySwiper.activeIndex;
                this.state.timerValue = currentSlide * this.state.sliderDelay;
                var percentage = (this.state.timerValue / (parseInt(this.state.faceCnt) * this.state. sliderDelay)) * 100;
                if (percentage == 0) {
                    document.querySelector("#active-bar").style.width="11px";
                } else {
                    // console.log("percentage==================>2",percentage);
                    document.querySelector("#active-bar").style.width=percentage+"%";
                }
                clearInterval(this.state.timerId)
            }
        }
    }
    clickSeekBar(e) {
        var left = (e.pageX - e.target.getBoundingClientRect().left);
        var totalWidth = document.querySelector("#custom-seekbar").offsetWidth;
        var percentage = (left / totalWidth) * 100;
        var slideIndex = Math.round(left * parseInt(this.state.faceCnt) / totalWidth);
        if (slideIndex > parseInt(this.state.faceCnt)) {
            slideIndex = parseInt(this.state.faceCnt);
        }
        this.state.mySwiper.slideTo(slideIndex, 1000, false);
        this.state.timerValue = slideIndex * this.state.sliderDelay;
        var percentage = (this.state.timerValue / (parseInt(this.state.faceCnt) * this.state.sliderDelay)) * 100;
        if (percentage == 0) {
            document.querySelector("#active-bar").style.width="11px";
        } else {
            document.querySelector("#active-bar").style.width=percentage + "%";
        }
        this.state.mySwiper.autoplay.start();
    }
    loadMsiteClasses() {
        console.log("loadMsiteClasses======>");
        if (window.innerWidth < 767) {
            actions.removeSelfClass("R17_75","R15_75");
            actions.removeSelfClass("R15_75","R17_75");
            actions.removeSelfClass("M15_pink","M13_pink");
            actions.removeSelfClass("M13_pink","M15_pink");
            actions.removeSelfClass("M15_61","M13_61");
            actions.removeSelfClass("M13_61","M15_61");
            // document.querySelector('.video-container').find('.R17_75').addClass('R15_75');
            // document.querySelector('.video-container').find('.R15_75').removeClass('R17_75');
            // document.querySelector('.face_star').find('.M15_pink').addClass('M13_pink');
            // document.querySelector('.face_star').find('.M13_pink').removeClass('M15_pink');
            // document.querySelector('.face_star').find('.M15_61').addClass('M13_61');
            // document.querySelector('.face_star').find('.M13_61').removeClass('M15_61');

        }
    }
    // downloadVideo(childname, month_year,flag) {
    //     console.log("downloadVideo=====>",flag);
    //     if(flag=='SV'){
    //         document.querySelector(".shareBy").style.display="block";
    //         document.querySelector(".shareBy-overlay").style.display="block";
    //         if (window.innerWidth < 767) {
    //             document.querySelector("body").style.overflow="hidden";
    //         }
    //     }
    //     if (this.state.faceCnt > 0) {
    //         var monthYeararr = month_year.split(" ");
    //         if (monthYeararr.length > 1) {
    //             var month = this.getMonthFromString(monthYeararr[0]);
    //         } else {
    //             var month = "";
    //         }
    //     var postData={
    //         'childId':this.state.selectedChild,
    //         'month':month,
    //         'year':monthYeararr[1]
    //     }
    //     var url = global.api_ci_url + "Face/getDownloadVideo";
    //     // var url = global.api_url + "faceaday/makevideo";
    //     service.postServiceCall(url, postData).then((json) => {
    //         console.log("framelist==============>",json['result']);
    //         if (json['result']) {
    //             if(flag=="SV"){
    //                 Cookies.set("faceVideo", json['result'], 1);
    //             }else{
    //                 var videoname = childname + "_Face_A_Day_" + month + monthYeararr[1] + ".mp4";
    //                 this.downloadFile(json['result'], videoname);
    //             }
    //         }
    //         service.hideLoader();
    //     }).catch((error) => {
    //         console.error(error);
    //         service.hideLoader();
    //     });
        
    // }else {
    //     document.querySelector(".alertmsg").innerHTML=("Kindly upload at least one image to download video");
    //     document.querySelector('.alertMsg-overlay').style.display="block";
    //     setTimeout(() => {
    //         document.querySelector('.alertMsg-overlay').style.display="block";
    //         this.props.history.push('/tools/capture-baby-moments');
    //     }, 1000);
    //     }
    // }
    getMonthFromString(mon) {
        var d = Date.parse(mon + "1, 2012");
        if (!isNaN(d)) {
            return new Date(d).getMonth() + 1;
        }
        return -1;
    }
    downloadFile(data, fileName, type = "video/plain") {
        const a = document.createElement("a");
        a.style.display = "none";
        document.body.appendChild(a);
        a.href = window.URL.createObjectURL(
            new Blob([data], {
                type
            })
        );
        a.setAttribute("download", fileName);
        a.click();
        window.URL.revokeObjectURL(a.href);
        document.body.removeChild(a);
    }
    uploadToMemory() {
        if (this.state.faceCnt > 0) {
            // window.location.href = redirect_url + "memories/memoriesupload";
            this.props.history.push('/tools/capture-baby-moments');
        } else {
            document.querySelector(".alertmsg").innerHTML=("Kindly upload at least one image to download video");
            document.querySelector('.alertMsg-overlay').style.display="block";
            setTimeout(() => {
                document.querySelector('.alertMsg-overlay').style.display="block";
                this.props.history.push('/tools/capture-baby-moments');
            }, 1000);
        }
       
    }
    // shareOn(e) {
    //     console.log("shareIcon=====>",e.target.parentNode.nextSibling);
    //     document.querySelector(".shareBy").style.display="none";
    //     e.target.parentNode.nextSibling.style.display="block";
    //     // document.querySelector(".share_trans").style.display="block";
    //     document.querySelector(".share-overlay").style.display="block";
    //     if (window.innerWidth < 767) {
    //         document.querySelector("body").style.overflow="hidden";
    //     }
    // }
    // shareAtricle(e, shareoption) {
    //     let shareurl;
    //     if (this.state.faceCnt > 0) {
    //         document.querySelector('.sharing-options').style.display="none";
    //         document.querySelector('.share-overlay').style.display="none";
    //         document.querySelector("body").style.overflow="auto";
    //         Cookies.set("faceVideoAutoUpload", "true", 1);
    //         var articleurl = "http:" +"//parenting.firstcry.com/memories/memoriesupload";
    //         if (shareoption == "facebook") {
    //             shareurl = 'https://www.facebook.com/sharer/sharer.php?u='
    //         } else if (shareoption == "google") {
    //             shareurl = 'https://plus.google.com/share?url='
    //         } else if (shareoption == "twitter") {
    //             shareurl = 'https://twitter.com/share?url='
    //         } else if (shareoption == "pintrest") {
    //             shareurl = '//www.pinterest.com/pin/create/button/?url='
    //         }
    //         var sharewindow = window.open(shareurl + articleurl, shareoption + '-popup', 'height=350,width=600');
    //         if (sharewindow.focus) {
    //             sharewindow.focus()
    //         }
    //         return false;
    //     } else {
    //         document.querySelector(".alertmsg").innerHTML=("Kindly upload at least one image to download video");
    //         document.querySelector('.alertMsg-overlay').style.display="block";
    //         setTimeout(() => {
    //             document.querySelector('.alertMsg-overlay').style.display="block";
    //             this.props.history.push('/tools/capture-baby-moments');
    //         }, 1000);
    //     }
    // }
    domClick(event) {
        console.log("domClick==================================>", event.target);
        if (document.querySelector(".shareBy") && document.querySelector(".shareBy").style.display=="block" && !event.target.classList.contains("share_face")) {
            document.querySelector(".shareBy").style.display="none";
        }else if(event.target.classList.contains("share-overlay") || event.target.classList.contains("shareBy-overlay")){
            event.target.style.display="none";
            document.querySelector('.sharing-options').style.display="none";
        }else {
            return false;
        }
    }
    componentWillUnmount() {
        document.removeEventListener("click", this.domClick);  
    }
    render() {
        return (
            <main className="main-container Face">
                <Helmet
                    title="Capture Your Baby Moments Everyday - FirstCry Parenting"
                    meta={[
                        { "name": "Preserving baby memories is one of the best ways to save the precious moments of your baby so that you can’t miss out those lovely & funny moments of your child’s first year. With capture baby moments tool this is made easy. Picture today." },
                        {"name":"keywords","content":"capturing baby moments, picturing baby moments"},{ "name": "atdlayout", "content": "tools_sp" }
                    ]}
                />
                <div className="title">
                    <div className="breadcrumb R11_9e">
                        <span><Link to={service.getRedirectUrl("/")} className="R11_9e">Home</Link></span>
                        <span className="R11_9e breadcrum_icon" data-icon-font="l"></span>
                        <span><Link to={service.getRedirectUrl("/tools")} className="R11_9e">Tools</Link></span>
                        <span className="R11_9e breadcrum_icon" data-icon-font="l"></span>
                        <span>Baby Moments</span>
                    </div>
                    <h1 className="B24_00">Slideshow For {this.state.month}</h1>
                    {/* {this.state.isMobile < 767 ?
                        (
                            <div className="export_share_container right share_desktop">
                                <span className="B20_42 icon left downloadCont" data-icon-font="^" onClick={()=>{this.downloadVideo(this.state.selectchildName,this.state.month,'DV')}}></span>
                                <span className="B20_42 icon left share_face" data-icon-font=")" onClick={()=>{this.downloadVideo(this.state.selectchildName,this.state.month,'SV')}}></span>
                            </div>
                        ):(
                            <div className="export_share_container right share_mobile">
                                <span className="B20_42 icon left downloadCont" data-icon-font="^"  onClick={()=>{this.downloadVideo(this.state.selectchildName,this.state.month,'DV')}}></span>
                                <span className="B20_42 icon left share_face" data-icon-font=")" onClick={()=>{this.downloadVideo(this.state.selectchildName,this.state.month,'SV')}}></span>
                            </div>
                        )
                    } */}
                </div>
                <div className="sub-container left">
                    <div className="data-container left Face">
                        <div className="video-container">
                            {/* <div className="shareBy-overlay"></div>
                            <div className="shareBy">
                                <span className="M15_42" onClick={()=>{this.uploadToMemory()}}>Parenting</span>
                                <span className="M15_42" onClick={(e)=>{this.shareOn(e)}}>Other Platform</span>
                            </div>
                            <div className="sharing-options">
                                <div className="sharing_icons left">
                                    <ul className="">
                                        <li className="whatsapp-share left" onClick={(e) => this.shareAtricle(e, 'whatsapp')}>
                                            <span className="M16_61 social-share" id="whatsapp">
                                                <img src="https://parenting.firstcry.com/discussions/images/whatsapp.png" className="fetusfacebookimg" alt="" />
                                            </span>
                                        </li>
                                        <li className="facebook-share left" onClick={(e) => this.shareAtricle(e, 'facebook')}>
                                            <span className="M16_61 social-share" id="facebook">
                                                <img src={require('../images/facebook.png')} className="facebookimg" alt="" />
                                            </span>
                                        </li>
                                        <li className="twitter-share left" onClick={(e) =>this.shareAtricle(e, 'twitter')}>
                                            <span className="M16_61 social-share" id="twitter">
                                                <img src={require('../images/twitter.png')} className="twitterimg" alt="" />
                                            </span>
                                        </li>
                                        <li className="twitter-share left" onClick={(e) => this.shareAtricle(e, 'pintrest')}>
                                            <span className="M16_61 social-share" id="pintrest">
                                                <img src={require('../images/pintrest.png')} className="pintrestimg" alt="" />
                                            </span>
                                        </li>
                                    </ul>
                                </div>
                            </div> 
                            <div className="share-overlay"></div>*/}
                            <input type="hidden" id="faceCnt" value={this.state.faceCnt}></input>
                            <div>
                                <audio id="faceAudio" src={require('../../assets/face_a_day_audio.mp3')} hidden>
                                    {/* <source src={require('../../assets/face_a_day_audio.mp3')} type="audio/mp3"/> */}
                                    {/* <source src="https://parenting.firstcry.com:3000/media/face_a_day_audio.c9190a3b.mp3" type="audio/mp3"/> */}
                                </audio>
                            </div>
                            <div>
                                <div className="slideshow_title slideshow_page R17_75">
                                    Play {this.state.selectchildName}'s Face A Day Slideshow for {this.state.month}
                                </div>
                                {/* <!-- slide show starts -->             */}
                                <div className="slideshow-container">
                                    <section className="swiper-main">
                                        <div className="swiper-container">
                                            <div className="swiper-wrapper"> 
                                            {
                                            this.state.FaceData=="No Data Found" || this.state.FaceData=="Unsuccess" ? null:(
                                            this.state.FaceData && this.state.FaceData.length > 0 && this.state.FaceData.map(frameList => 
                                                    <div className="swiper-slide">
                                                        <div className="swiper-image">
                                                            <img className="" src={frameList.frameImage}/>
                                                        </div>
                                                    </div>
                                            ))
                                            } 
                                            </div>
                                        </div>
                                    </section>
                                    <div className="face_star">
                                        <img className="" src={require('../images/face-a-day/star-face-of-day.png')} />
                                        <div className="star_body">
                                            <div className="star_name M15_pink">
                                                {this.state.selectchildName}
                                                </div>
                                            <div className="star_text M15_61">Face a Day Slideshow</div>
                                        </div>
                                    </div>
                                    </div>
                                    <div className="slider_container"> 
                                    <span className="clickhere" onClick={()=>{this.playVideo()}}>
                                        <span className="icon pause" data-icon-font="&#xe03e;"></span>
                                        <span className="icon play" data-icon-font="&#xe03d;"></span>
                                    </span>
                                    <div id="custom-seekbar" onClick={(e)=>{this.clickSeekBar(e)}}>                            
                                        <span id="active-bar">
                                            <span className="active-dot"></span>
                                        </span>
                                    </div>
                                    <div className="R12_75 audio-link">https://www.bensound.com/royalty-free-music</div>
                             </div>
                             </div>
                             <div className="loader-overlay">          
                                <div className="loader-img">
                                    <img src="//parenting.firstcry.com/vaccination/images/ajax-loader-tr.svg" />
                                </div>
                            </div>
                            <div className="alertMsg-overlay">
                                <div className="alert-popup">
                                    <span className="alertmsg" ></span>
                                </div>
                            </div> 
                        </div>
                    </div>
                </div>                
                <Right url={this.props.match.url} />
            </main>
        )

    }
}

export default SlideShow;



// WEBPACK FOOTER //
// src/shared/tools/Face/SlideShow.js